import { render, staticRenderFns } from "./ClinexTest.vue?vue&type=template&id=0a0e353c&scoped=true"
import script from "./ClinexTest.vue?vue&type=script&lang=js"
export * from "./ClinexTest.vue?vue&type=script&lang=js"
import style0 from "./ClinexTest.vue?vue&type=style&index=0&id=0a0e353c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0e353c",
  null
  
)

export default component.exports